const savedData = {
  state: "persist:root"
};

export {
  savedData
};